import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ColorFilter, type ColorFilterProps } from '~/components/Filters/ColorFilter/ColorFilter';
import { type ColorToggleParams } from '~/components/Filters/ColorFilter/ColorFilterCard';
import { SingleFilterContainer } from '~/components/Filters/SingleFilters/SingleFilterContainer';
import { type SingleFilterProps } from '~/components/Filters/types';
import {
  addColorFilterValueAction,
  clearColorFilterValuesAction,
  removeColorFilterValueAction,
} from '~/store/filters/actions';
import { hasColorsFiltersValuesSelector, selectedColorsFiltersSelector } from '~/store/filters/selectors';
import { useAirSelector } from '~/utils/ReduxUtils';
export type SingleColorFilterProps = {
  colors: ColorFilterProps['colors'];
} & SingleFilterProps;

export const SingleColorFilter = memo(({ colors, onApplyClick }: SingleColorFilterProps) => {
  const dispatch = useDispatch();
  const hasValues = useAirSelector(hasColorsFiltersValuesSelector);
  const selectedColors = useSelector(selectedColorsFiltersSelector);

  const clearValues = useCallback(() => {
    dispatch(clearColorFilterValuesAction());
  }, [dispatch]);

  const handleColorToggle = useCallback(
    ({ color, isSelected }: ColorToggleParams) => {
      if (isSelected) {
        dispatch(addColorFilterValueAction({ color: color.hex }));
      } else {
        dispatch(removeColorFilterValueAction({ color: color.hex }));
      }

      onApplyClick();
    },
    [dispatch, onApplyClick],
  );

  return (
    <SingleFilterContainer hasValues={hasValues} currentFilter="color" onClearClick={clearValues}>
      <ColorFilter colors={colors} onClick={handleColorToggle} selectedColors={selectedColors.colors} />
    </SingleFilterContainer>
  );
});

SingleColorFilter.displayName = 'SingleColorFilter';
